export default {
  LOADING_QUOTE: 'MARKETS_VIEW_TABLE_TOTAL_ROW_LOADING_QUOTE',
  LOADED_QUOTE: 'MARKETS_VIEW_TABLE_TOTAL_ROW_LOADED_QUOTE',
  PLACING_ORDER: 'MARKETS_VIEW_TABLE_TOTAL_ROW_PLACING_ORDER',
  PLACED_ORDER: 'MARKETS_VIEW_TABLE_TOTAL_ROW_PLACED_ORDER',
};
